function detect (ua, platform) {
  var os = {}, browser = {},
    webkit = ua.match(/Web[kK]it[/]{0,1}([\d.]+)/),
    android = ua.match(/(Android);?[\s/]+([\d.]+)?/),
    ios = ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
    osx = !!ua.match(/\(Macintosh; Intel /),
    // ipad 13的ua被调整了。。
    ipad = ua.match(/(iPad).*OS\s([\d_]+)/) || (osx && navigator.maxTouchPoints > 1),
    ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/),
    iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
    webos = ua.match(/(webOS|hpwOS)[\s/]([\d.]+)/),
    win = /Win\d{2}|Windows/.test(platform),
    wp = ua.match(/Windows Phone ([\d.]+)/),
    touchpad = webos && ua.match(/TouchPad/),
    kindle = ua.match(/Kindle\/([\d.]+)/),
    silk = ua.match(/Silk\/([\d._]+)/),
    blackberry = ua.match(/(BlackBerry).*Version\/([\d.]+)/),
    bb10 = ua.match(/(BB10).*Version\/([\d.]+)/),
    rimtabletos = ua.match(/(RIM\sTablet\sOS)\s([\d.]+)/),
    playbook = ua.match(/PlayBook/),
    edge = ua.match(/Edge/),
    chrome = !edge && (ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/)),
    firefox = ua.match(/Firefox\/([\d.]+)/) || ua.match(/FxiOS\/([\d.]+)/),
    firefoxos = ua.match(/\((?:Mobile|Tablet); rv:([\d.]+)\).*Firefox\/[\d.]+/),
    ie = ua.match(/MSIE\s([\d.]+)/) || ua.match(/Trident\/[\d](?=[^?]+).*rv:([0-9.].)/),
    webview = !chrome && ua.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/),
    safari = webview || ua.match(/Version\/([\d(.,)]+)([^S](Safari)|[^M]*(Mobile)[^S]*(Safari))/),
    x64 = ua.match(/(wow64|Win64|x64)/ig);

  // Todo: clean this up with a better OS/browser seperation:
  // - discern (more) between multiple browsers on android
  // - decide if kindle fire in silk mode is android or not
  // - Firefox on Android doesn't specify the Android version
  // - possibly devide in os, device and browser hashes

  if (webkit) browser.webkit = true, browser.version = webkit[1]
  if (android) os.android = true, os.version = android[2]
  if (ios) os.ios = true
  if (iphone && !ipod) os.ios = os.iphone = true, os.version = iphone[2].replace(/_/g, '.')
  if (ipad) os.ios = os.ipad = true, os.version = ipad[2] ? ipad[2].replace(/_/g, '.') : (safari? (safari[1] || '').replace(/,/g, '.') : '')
  if (ipod) os.ios = os.ipod = true, os.version = ipod[3] ? ipod[3].replace(/_/g, '.') : null
  if (wp) os.wp = true, os.version = wp[1]
  if (webos) os.webos = true, os.version = webos[2]
  if (touchpad) os.touchpad = true
  if (blackberry) os.blackberry = true, os.version = blackberry[2]
  if (bb10) os.bb10 = true, os.version = bb10[2]
  if (rimtabletos) os.rimtabletos = true, os.version = rimtabletos[2]
  if (playbook) browser.playbook = true
  if (kindle) os.kindle = true, os.version = kindle[1]
  if (silk) browser.silk = true, browser.version = silk[1]
  if (!silk && os.android && ua.match(/Kindle Fire/)) browser.silk = true
  if (chrome) browser.chrome = true, browser.version = chrome[1]
  if (firefox) browser.firefox = true, browser.version = firefox[1]
  if (firefoxos) os.firefoxos = true, os.version = firefoxos[1]
  if (ie) browser.ie = true, browser.version = ie[1]
  if (edge) browser.edge = true, browser.version = edge[1]
  if (safari && (osx || os.ios || win)) {
    browser.safari = true
    if (!os.ios) browser.version = (safari[1] || '').replace(/,/g, '.') 
  }
  if (webview) browser.webview = true
  if (x64) os.x64 = true

  os.tablet = !!(ipad || playbook || (android && !ua.match(/Mobile/)) ||
    (firefox && ua.match(/Tablet/)) || (ie && !ua.match(/Phone/) && ua.match(/Touch/)))
  os.phone  = !!(!os.tablet && (android || iphone || ipod || webos || blackberry || bb10 ||
    (chrome && ua.match(/Android/)) || (chrome && ua.match(/CriOS\/([\d.]+)/)) ||
    (firefox && ua.match(/Mobile/)) || (ie && ua.match(/Touch/))))
  
  // 云游戏
  os.neteaseCloud = !!(ua.match(/NeteaseCloud/))
  // TV
  os.tv = !!(ua.match(/NeteaseCloud.tv/))
  // 单apk
  os.single = !!(ua.match(/single/))
  // 平台
  os.platform = !!(ua.match(/platform/))
  // electron
  os.electron = !!(ua.match(/electron/))
  // pc客户端
  os.pc = !!(ua.match(/NeteaseCloud.pc/))
  // ios APP
  os.iosAPP = !!(ua.match(/NeteaseCloud.ios/))


  if (os.neteaseCloud) {
    // channel
    const channel = ua.match(/NCGChannel\((.*)\)/)
    os.channel = channel ? channel[1] : ''
  }
 
  return {
    os,
    browser
  }
}

const $detect = detect.call(null,  navigator.userAgent, navigator.platform)

export default $detect